import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import { currentViewportSelector } from 'selectors/viewportSelectors'
import { compareViewports } from 'helpers/viewportHelpers'
import ExternalStickyHeader, {
  ExternalStickyHeaderStateProps,
  ExternalStickyHeaderOwnProps,
} from 'components/features/external/ExternalStickyHeader/ExternalStickyHeader'


const HEADER_HEIGHT = 24
const HEADER_VERTICAL_PADDING = 24

const mapStateToProps = (state: State): ExternalStickyHeaderStateProps => {
  const currentViewport = currentViewportSelector(state)

  const height = compareViewports(currentViewport, '<=', 'w768')
    ? HEADER_HEIGHT
    : 2 * HEADER_HEIGHT

  const padding = compareViewports(currentViewport, '<=', 'w768')
    ? 2 * HEADER_VERTICAL_PADDING / 1.5
    : 2 * HEADER_VERTICAL_PADDING

  return {
    headerOffset: height + padding,
  }
}

export default connect<ExternalStickyHeaderStateProps, {}, ExternalStickyHeaderOwnProps>(
  mapStateToProps
)(ExternalStickyHeader)
